module.exports = __webpack_public_path__ + "static/media/mainvisual.00baf40.webm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/mainvisual.webm
// module id = CxWR
// module chunks = 1